var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mb-3", attrs: { id: "cart" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.loading } },
        [
          _c(
            "b-row",
            { staticClass: "border-bottom border-top py-3" },
            [
              _c("b-col", { attrs: { md: "" } }, [
                _c("strong", [_vm._v("Product")]),
              ]),
              _c(
                "b-col",
                { staticClass: "d-none d-md-block", attrs: { md: "2" } },
                [_c("strong", [_vm._v("Quantity")])]
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-none d-md-block text-right",
                  attrs: { md: "1" },
                },
                [_c("strong", [_vm._v("Unit Price")])]
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-none d-md-block text-right",
                  attrs: { md: "1" },
                },
                [_c("strong", [_vm._v("Subtotal")])]
              ),
            ],
            1
          ),
          _vm.cart.items.length === 0
            ? _c(
                "b-row",
                { staticClass: "border-bottom" },
                [
                  _c("b-col", [
                    !_vm.loading
                      ? _c("p", { staticClass: "lead my-3" }, [
                          _vm._v("Your cart is empty!"),
                        ])
                      : _vm._e(),
                    _vm.loading
                      ? _c("p", { staticClass: "lead my-3" }, [
                          _vm._v("Loading..."),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.cart.items, function (item, idx) {
            return _c("item", {
              key: idx,
              attrs: { item: item },
              on: { updated: _vm.refresh },
            })
          }),
          _c(
            "b-row",
            { staticClass: "border-bottom py-3" },
            [
              _c("b-col", { staticClass: "text-right" }, [
                _c("strong", [_vm._v("Item Subtotal:")]),
              ]),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { md: "2" } },
                [
                  _vm._v("£" + _vm._s(_vm.cart.subtotal)),
                  _vm.cart.subtotalDiscount != "0.00"
                    ? [
                        _c("br"),
                        _c("em", [
                          _vm._v("Save £" + _vm._s(_vm.cart.subtotalDiscount)),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-row",
            {
              staticClass: "border-bottom py-3",
              attrs: { "align-v": "center" },
            },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-right", attrs: { lg: "6" } },
                        [
                          _vm.isDeliveryAvailable
                            ? _c("b-form-radio-group", {
                                staticClass: "mb-2 mb-lg-0",
                                attrs: {
                                  options: _vm.deliveryOptions,
                                  "button-variant": "brand",
                                  buttons: "",
                                },
                                model: {
                                  value: _vm.deliveryType,
                                  callback: function ($$v) {
                                    _vm.deliveryType = $$v
                                  },
                                  expression: "deliveryType",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-right", attrs: { lg: "6" } },
                        [
                          _vm.deliveryType == "delivery"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-2 mb-lg-0",
                                  attrs: {
                                    label: "Calculate Postage:",
                                    "label-cols-sm": "6",
                                    "label-align-sm": "right",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("b-form-input", {
                                        attrs: { placeholder: "Postcode" },
                                        model: {
                                          value: _vm.postcode,
                                          callback: function ($$v) {
                                            _vm.postcode = $$v
                                          },
                                          expression: "postcode",
                                        },
                                      }),
                                      _c(
                                        "b-input-group-append",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "brand" },
                                              on: { click: _vm.setPostcode },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("calculate")]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "b-alert",
                            {
                              staticClass: "mb-0 d-inline-block",
                              attrs: {
                                show: !_vm.isDeliveryAvailable,
                                variant: "warning",
                              },
                            },
                            [_vm._v("This cart is collection only.")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-col", { staticClass: "text-right", attrs: { md: "2" } }, [
                _c("strong", [_vm._v("Postage:")]),
              ]),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { md: "2" } },
                [
                  _vm._v("£" + _vm._s(_vm.cart.postage)),
                  _vm.deliveryType == "collection"
                    ? [
                        _c("br"),
                        _c("small", [_c("em", [_vm._v("(Collection)")])]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-row",
            {
              staticClass: "border-bottom py-3",
              attrs: { "align-v": "center" },
            },
            [
              _c("b-col", { staticClass: "text-right", attrs: { md: "10" } }, [
                _c("strong", [_vm._v("Subtotal:")]),
              ]),
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { md: "2" } },
                [
                  _vm._v("£" + _vm._s(_vm.cart.total)),
                  _vm.cart.totalDiscount != "0.00"
                    ? [
                        _c("br"),
                        _c("em", { staticClass: "text-success" }, [
                          _vm._v("Save £" + _vm._s(_vm.cart.totalDiscount)),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-row",
            {
              staticClass: "border-bottom py-3",
              attrs: { "align-v": "center" },
            },
            [
              _c("b-col", { staticClass: "text-right" }, [
                _c("strong", [_vm._v("VAT (20%):")]),
                _c("br"),
                _vm.cart.totalIncVAT == _vm.cart.total
                  ? _c("small", [_c("em", [_vm._v("(included)")])])
                  : _vm._e(),
              ]),
              _c("b-col", { staticClass: "text-right", attrs: { md: "2" } }, [
                _vm._v("£" + _vm._s(_vm.cart.vat)),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "border-bottom py-3" },
            [
              _c("b-col", { staticClass: "text-right" }, [
                _c("strong", [_vm._v("Total (inc VAT):")]),
              ]),
              _c("b-col", { staticClass: "text-right", attrs: { md: "2" } }, [
                _vm._v("£" + _vm._s(_vm.cart.totalIncVAT)),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "mb-3 mb-md-0",
                  attrs: { md: "6", order: "2", "order-md": "1" },
                },
                [
                  _vm.cart.items.length > 0
                    ? _c(
                        "div",
                        { staticClass: "help-functions" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-2",
                              attrs: { variant: "danger" },
                              on: { click: _vm.emptyCart },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                              _vm._v(" Empty Cart"),
                            ]
                          ),
                          _c("br"),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.email-modal",
                                  modifiers: { "email-modal": true },
                                },
                              ],
                              attrs: { variant: "primary" },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("email"),
                              ]),
                              _vm._v(" Email Us"),
                            ]
                          ),
                          _c("shipping-zones", {
                            staticClass: "mt-3",
                            attrs: { "zone-prices": _vm.cart.postageOptions },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "b-col",
                {
                  staticClass: "text-right",
                  attrs: { md: "6", order: "1", "order-md": "2" },
                },
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "d-inline-block mb-2",
                      attrs: {
                        show: _vm.cart.dueDate.from > 0,
                        variant: "info",
                      },
                    },
                    [
                      _vm._v("Please expect dispatch of your purchase within "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.cart.dueDate.from) +
                            " to " +
                            _vm._s(_vm.cart.dueDate.to) +
                            " working days"
                        ),
                      ]),
                      _vm._v(" as of " + _vm._s(_vm.today)),
                    ]
                  ),
                  _c(
                    "b-alert",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: !_vm.cart.postageValid,
                        variant: "danger",
                      },
                    },
                    [
                      _vm._v(
                        'Sorry, there was a problem calculating the postage for this order.  Please use the blue "E-Mail Us" button in the lower left to send your cart to us, and we will advise the correct postage cost.'
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { attrs: { id: "discount-codes" } },
                    [
                      _vm.cart.discountCode == null
                        ? _c("discount-code-selector", {
                            on: { "discount-code-applied": _vm.refresh },
                          })
                        : _c(
                            "b-alert",
                            {
                              staticClass: "d-inline-block mb-2",
                              attrs: { variant: "success", show: "" },
                            },
                            [
                              _vm._v("Discount code "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.cart.discountCode.code)),
                              ]),
                              _vm._v(" applied to cart "),
                              _c("br"),
                              _vm._v(
                                " " + _vm._s(_vm.cart.discountCode.description)
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        href: `/cart/checkout?postcode=${_vm.postcode}`,
                        variant: _vm.checkoutBtnVariant,
                        disabled: !_vm.isCheckoutEnabled,
                        size: "lg",
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("security"),
                      ]),
                      _vm._v(" Secure Checkout"),
                    ]
                  ),
                  _vm.isAdmin
                    ? _c(
                        "div",
                        { staticClass: "admin" },
                        [
                          _vm.isAdmin
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "mb-3",
                                  attrs: { variant: "info", size: "lg" },
                                  on: { click: _vm.processOrder },
                                },
                                [_vm._v("Process Order")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "email-modal",
            title: "Make a Sales Enquiry",
            "hide-footer": "",
          },
        },
        [_c("enquiry", { on: { sent: _vm.onEnquirySend } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }